import DialogButton from './DialogButton';
export default DialogButton;